import { module } from 'modujs';
import Lenis from "@studio-freight/lenis";
import Emitter from "tiny-emitter/instance";

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'number': 'numberClick' } };
        this.wrapper = this.$( 'wrapper' )[0];
        this.input = this.$( 'input' )[0];
        this.selectedNumber = this.el.querySelector( '[data-number-select="number"].active');
        this.isActive = false;
        Emitter.on('click-outside', this.closePopup.bind( this ) );
        this.input.addEventListener( 'click', this.openPopup.bind( this) );
    }

    numberClick( e ){
        e.stopPropagation();
        this.selectedNumber.classList.remove( 'active' );
        this.selectedNumber = e.currentTarget;
        this.input.value = this.selectedNumber.dataset.value;
        this.selectedNumber.classList.add( 'active' );
        this.input.dispatchEvent(new Event('input'));
        this.closePopup();
    }

    openPopup( e ){
        if( this.isActive ) return;
        this.input.blur();
        e.stopPropagation();
        this.isActive = true;
        this.el.classList.add( 'active' );
        this.call( 'stop', false, 'Scroll' );
    }

    closePopup(){
        if( ! this.isActive ) return;
        this.el.classList.remove( 'bottom' );
        this.el.classList.remove( 'active');
        this.call( 'start', false, 'Scroll' );
        this.isActive = false;
    }

    setPopupPosition(){
        this.box = this.wrapper.getBoundingClientRect();
        if(  this.box.top - this.box.height > 0  && this.box.height + this.box.top > window.innerHeight){
            this.el.classList.add( 'bottom' );
        } else {
            this.el.classList.remove( 'bottom' );
        }
    }


    init() {}
    destroy(){}
}
